<template>
  <div class="work" :style="workStyle">
    <work-frame
      :image="image"
      :ratio="ratio"
      :width="width"
      :link="link"
    ></work-frame>
    <div class="work-info-container" :style="workInfoContainerStyle">
      <work-info
        :title="title"
        :subtitle="subtitle"
      ></work-info>
    </div>
  </div>
</template>

<script>
import WorkFrame from './WorkFrame';
import WorkInfo from './WorkInfo';

export default {
  components: {
    WorkFrame,
    WorkInfo,
  },
  props: [
    'image',
    'title',
    'subtitle',
    'ratio',
    'width',
    'link',
  ],
  data() {
    return {
    };
  },
  computed: {
    workStyle() {
      if (this.width < 1) {
        return {
          width: `${this.width * 100}%`,
        };
      }

      return {
        width: `${this.width}px`,
      };
    },
    workInfoContainerStyle() {
      if (this.width < 1) {
        return {
          textAlign: this.infoAlign || 'right',
        };
      }

      return {
        textAlign: this.infoAlign || 'right',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.work {

}

.work-info-container {
  width: 100%;
}
</style>



/** WEBPACK FOOTER **
 ** Work.vue?4da6b7b8
 **/